import qs from "qs";
import axios from "axios";
import Jsona from "jsona";

const base_url = process.env.VUE_APP_API_BASE_URL;
let url = `${base_url}`;
const jsona = new Jsona();

function list(params) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
    params: params,
    paramsSerializer: function (params) {
      return qs.stringify(params, { encode: false });
    },
  };

  return axios.get(`${url}/elixiopay-transactions`, options).then((response) => {
    return {
      list: jsona.deserialize(response.data),
      meta: response.data.meta,
    };
  });
}

function get(id) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .get(`${url}/elixiopay-transactions/${id}?include=organization,thirdPartyService,payable`, options)
    .then((response) => {
      let transaction = jsona.deserialize(response.data);
      delete transaction.links;
      return transaction;
    });
}

function add(elixiopayTransaction) {
  const payload = jsona.serialize({
    stuff: elixiopayTransaction,
    includeNames: null,
  });

  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .post(`${url}/elixiopay-transactions?include=`, payload, options)
    .then((response) => {
      return jsona.deserialize(response.data);
    });
}

function update(elixiopayTransaction) {
  const payload = jsona.serialize({
    stuff: elixiopayTransaction,
    includeNames: [],
  });

  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .patch(`${url}/elixiopay-transactions/${elixiopayTransaction.id}?include=`, payload, options)
    .then((response) => {
      return jsona.deserialize(response.data);
    });
}

function destroy(id) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios.delete(`${url}/elixiopay-transactions/${id}`, options);
}

function getStats(params = {}) {
  const options = {
    params: params,
    paramsSerializer: function (params) {
      return qs.stringify(params, { encode: false });
    },
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  };

  return axios
    .get(`${url}/elixiopay-transactions-stats`, options)
    .then((response) => {
      return response.data.data;
    });
}

function resync(transactionId) {
  const options = {
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  };

  return axios
    .post(`${url}/elixiopay-transactions/${transactionId}/resync`, {}, options)
    .then((response) => {
      return response.data;
    });
}

function initiatePayment(paymentData) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .post(`${url}/elixio-pay/initiate-payment`, paymentData, options)
    .then((response) => {
      return response.data;
    });
}

function checkStatus(transactionId) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .get(`${url}/elixio-pay/check-status/${transactionId}`, options)
    .then((response) => {
      return response.data;
    });
}

export default {
  list,
  get,
  add,
  update,
  destroy,
  getStats,
  resync,
  initiatePayment,
  checkStatus,
};
